import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import moment from 'moment-timezone'
import { DayPicker } from 'react-day-picker'
import useConfig from '../../hooks/useConfig'
import { themeFontSize, themeFontWeight, themeColor } from '../../util/themeLenses'
import { LocaleMapping, toDate } from '@elparking/utils'
const mediaScreenMobile = (props) =>
    `@media screen and (max-width: ${props.theme.screens.medium})`

export const StyledDayPicker = styled(DayPicker)`
    font-size: 1rem;
    color: ${themeColor('darkMain')};
    font-weight: ${themeFontWeight('regular')};
    display: flex;
    align-items: center;

    .rdp-month {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        width: 570px;

        ${mediaScreenMobile} {
            width: 100%;
        }
    }
    .rdp-month_grid {
        width: 100%;
        margin-left: 0;
        margin-right: 0;
        display: table;
        margin: 0 1em;
        border-spacing: 0;
        border-collapse: collapse;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }
    .rdp-months {
        outline: none;
        width: 100%;
        position: relative;
        flex-direction: row;
        padding-bottom: 1em;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }
    .rdp-month_caption {
        display: table-caption;
        padding: 0 0.5em;
        margin-bottom: 1em;
        font-weight: ${themeFontWeight('medium')};
        text-align: center;
        font-size: ${themeFontSize('xLarge')};
        line-height: 2.5em;
    }

    .rdp-caption_label {
        font-weight: 500;
        font-size: 1.15em;
    }

    .rdp-button_previous,
    .rdp-button_next {
        border: none;
        background-color: transparent;
        position: absolute;
        right: 1.5em;
        left: auto;
        background-size: 50%;
        background-repeat: no-repeat;
        color: #8B9898;
        cursor: pointer;
        width: 2.5em;
        height: 2.5em;
        outline: none;
        &:focus-visible {
            border: 1px solid ${themeColor('focusColor')};
            outline: 1px solid ${themeColor('focusColor')};
        }
    }

    .rdp-button_next:hover,
    .rdp-button_previous:hover {
        opacity: 0.8;
    }


    .rdp-button_next {
        right: 0;
    }
    .rdp-weekdays {
        display: table-header-group;
        margin-top: 1em;
    }

    .rdp-weekday {
        display: table-cell;
        padding: 0.5em;
        color: #8B9898;
        text-align: center;
        font-size: 0.875em;
    }

    .rdp-weekdays,
    .rdp-week{
        display: flex;
        justify-content: space-between;
        width: 100%;
    }
    .rdp-weeks {
        display: table-row-group;
    }

    .rdp-week {
        display: flex;
        -webkit-box-pack: justify;
        justify-content: space-between;
        width: 100%;
    }

    .rdp-weekday abbr[title] {
        border-bottom: none;
        text-decoration: none;
    }

    .rdp-day {
        display: table-cell;
        padding: 0.5em;
        border-radius: 50%;
        vertical-align: middle;
        text-align: center;
        cursor: pointer;
    }

    .rdp-day,
    .rdp-weekday {
        display: block;
        line-height: 2.5em;
        padding: 0;
        margin: 0;
        margin-bottom: 0.5em;
    }

    .rdp-weekday {
        font-weight: ${themeFontWeight('book')};
        color: ${themeColor('gray')};
    }

    .rdp-day_button{
        outline: none;
        text-align: center;
        border-radius: 50%;

        color: ${themeColor('gray')};
        border: 1px solid ${themeColor('main')};
        font-weight: ${themeFontWeight('regular')};

        &:focus-visible {
            border: 1px solid ${themeColor('focusColor')};
            outline: 1px solid ${themeColor('focusColor')};
        }
    }

    .rdp-day:selected {
        border: none;
        background-color: transparent;
        background-image: none;
        box-shadow: none;
        color: #4A90E2;
        font-size: 0.875em;
        cursor: pointer;
    }

    .rdp-day rdp-disabled  {
        cursor: default;
        color: rgb(139, 152, 152);
    }

    &:not(.rdp-disabled) .rdp-day:not(.rdp-disabled):not(.rdp-selected):not(.rdp-outside):hover > button,
    &:not(.rdp-disabled) .rdp-day:not(.rdp-disabled):not(.rdp-selected):hover > button {
        background-color: ${themeColor('main')};
        color: ${themeColor('white')};
    }

    .rdp-day--inactive,
    .rdp-disabled > button{
        color: ${themeColor('gray20')};
        background-color: inherit;
    }

    .rdp-day--inactive {
        position: relative;
        color: ${themeColor('gray20')};
    }

    .rdp-disabled > button {
        color: #DCE0E0;
        cursor: default;
        border: none;
        pointer-events: none;
        position: relative;

        &:after{
            content: '';
            position :absolute;
            left: 2em;
            top: 0;
            border-top: 1px solid ${themeColor('gray20')};
            width: 100%;
            transform: rotate(120deg);
            transform-origin: 0% 0%;
        }
    }

    .rdp-outside {
        color: #8B9898;
        cursor: default;
    }

    .rdp-today {
        color: #D0021B;
        font-weight: 700;
        background: ${themeColor('lightGray20')};
        font-weight: ${themeFontWeight('medium')};
    }

    .rdp-today.rdp-outside {
        font-weight: ${themeFontWeight('regular')};
    }


    .rdp-selected:not(.rdp-disabled):not(.rdp-outside) > button {
        position: relative;
    }

    .rdp-root:not(.rdp-root--interactionDisabled),
    .rdp-day:not(.rdp-disabled):not(.rdp-selected):not(.rdp-outside):hover {
      background-color: #F0F8FF;
    }

    .rdp-selected:not(.rdp-disabled):not(.rdp-outside):hover > button,
    .rdp-selected:not(.rdp-disabled):not(.rdp-outside) > button,
    .rdp-selected > button{
        color: ${themeColor('white')};
        background: ${themeColor('main')};
    }
    .rdp-chevron {
        fill: ${themeColor('main')};
    }

    .rdp-chevron:disabled {
        fill: ${themeColor('gray20')};
    }
`

const Days = ({
    selectedDay,
    onChange,
    onMonthChange,
    disabledDays,
    startMonth,
    endMonth,
    ...props
}) => {
    const country = useConfig('country')
    const flavor = useConfig('flavor')
    return (<StyledDayPicker
        mode='single'
        locale={LocaleMapping[moment.locale()]}
        onSelect={onChange}
        selected={selectedDay}
        showOutsideDays
        country={country}
        flavor={flavor}
        disabled={disabledDays}
        onMonthChange={onMonthChange}
        startMonth={startMonth ? toDate(startMonth) : null}
        endMonth={endMonth ? toDate(endMonth) : null}
        {...props}
    />)
}

Days.propTypes = {
    onChange: PropTypes.func,
    selectedDay: PropTypes.instanceOf(Date),
    onMonthChange: PropTypes.func,
    disabledDays: PropTypes.arrayOf(PropTypes.instanceOf(Date)),
    startMonth: PropTypes.instanceOf(Date),
    endMonth: PropTypes.instanceOf(Date),
}

Days.defaultProps = {
    onChange: () => {},
}

export default Days
